
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/physiotherapy",
      function () {
        return require("private-next-pages/physiotherapy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/physiotherapy"])
      });
    }
  